"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Account/Settings/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _noticeBar = require('web/services/context/noticeBar');

var _ListResultsStatus = require('web/components/ListResultsStatus'); var _ListResultsStatus2 = _interopRequireDefault(_ListResultsStatus);
var _Skeleton = require('web/components/Settings/Skeleton'); var _Skeleton2 = _interopRequireDefault(_Skeleton);
var _Form = require('web/components/Form');
var _Org = require('web/components/Settings/Org');
var _Headings = require('web/components/Settings/Headings');









const toValues = ({ MFARequired, QuickLoginPinAllowed, HidePatientPhones }) =>
  ({ MFARequired, QuickLoginPinAllowed, HidePatientPhones })

// Account → Settings (screen 08). The account's sign-in and privacy settings,
// which govern every org. Turning the account on creates them from the
// strictest of its orgs' values (D-117); there is no separate setup step.
const SettingsTab = ({ orgKey, onAccountChanged }) => {
  const [loaded, setLoaded] = _react.useState(null)
  const [hasLoadFailed, setHasLoadFailed] = _react.useState.call(void 0, false)
  const [values, setValues] = _react.useState(null)
  const [isSaving, setIsSaving] = _react.useState.call(void 0, false)
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )

  _react.useEffect.call(void 0, 
    () => {
      let isCurrent = true
      setLoaded(null)
      setHasLoadFailed(false)
      _actions2.default.getAccountSettings({ OrgKey: orgKey })
        .then(s => {
          if (!isCurrent) return
          setLoaded(s)
          setValues(toValues(s))
        })
        .catch(() => { if (isCurrent) setHasLoadFailed(true) })
      return () => { isCurrent = false }
    },
    [orgKey],
  )

  const setValue = _react.useCallback.call(void 0, 
    (key) => (v) => setValues(vs => vs && { ...vs, [key]: v }),
    [],
  )

  const save = () => {
    if (!values) return
    setIsSaving(true)
    _actions2.default.saveAccountSettings({ OrgKey: orgKey, ...values })
      .then(s => {
        setLoaded(s)
        setValues(toValues(s))
        onAccountChanged()
        showSuccessBar('Account settings saved')
      })
      .catch(() => showWarningBar('Failed to save account settings'))
      .finally(() => setIsSaving(false))
  }

  if (!loaded || !values) {
    return (
      _react2.default.createElement(_Org.TabWrapper, { classNameSuffix: "account-settings", __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
        ,  hasLoadFailed
          ? _react2.default.createElement(_ListResultsStatus2.default, { isLoading: false, resultsCount: 0, noResultsLabel: "Failed to load account settings."    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}} )
          : _react2.default.createElement(_Skeleton2.default, { label: "Loading account settings"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}} )
        
      )
    )
  }

  const isDirty = !loaded.Configured
    || values.MFARequired !== loaded.MFARequired
    || values.QuickLoginPinAllowed !== loaded.QuickLoginPinAllowed
    || values.HidePatientPhones !== loaded.HidePatientPhones

  return (
    _react2.default.createElement(_Org.TabWrapper, { classNameSuffix: "account-settings", __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}
      ,  !loaded.Configured && (
        // Only an account flagged before the enable step created its
        // settings (D-117) gets here: the strictest values, to save.
        _react2.default.createElement('p', { className: "settings--org-info--hint", role: "note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 92}}, "These settings aren't saved yet. They start from the strictest settings your organizations use today; save them to apply them to every organization."


        )
      )
      , _react2.default.createElement(_Headings.Subheader, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}, "Sign-in security" )
      , _react2.default.createElement(_Form.Toggle, {
        className: "settings--org-info--mfa-toggle",
        label: "Require SMS verification at login"    ,
        hint: "Applies to everyone on the account."     ,
        isChecked: values.MFARequired,
        onChange: setValue('MFARequired'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}}
      )
      , _react2.default.createElement(_Form.Toggle, {
        className: "settings--org-info--mfa-toggle",
        label: "Allow quick-login PIN"  ,
        hint: "Lets people on shared devices sign in with a PIN."         ,
        isChecked: values.QuickLoginPinAllowed,
        onChange: setValue('QuickLoginPinAllowed'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 105}}
      )
      , _react2.default.createElement(_Headings.Subheader, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 112}}, "Patient privacy" )
      , _react2.default.createElement(_Form.Toggle, {
        className: "settings--org-info--mfa-toggle",
        label: "Don't allow users to see patient phone numbers"       ,
        hint: "Applies to every organization. Users who aren't admins see patient numbers masked."           ,
        isChecked: values.HidePatientPhones,
        onChange: setValue('HidePatientPhones'), __self: this, __source: {fileName: _jsxFileName, lineNumber: 113}}
      )
      , _react2.default.createElement('span', { className: "settings--org-info--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 120}}, "Stays in each organization: name, address and contact details, translation, the SMS “Reply STOP” line, teams and phone numbers."


      )
      , _react2.default.createElement(_Form.Button, {
        className: "settings--org-info--submit-btn",
        isDisabled: !isDirty || isSaving,
        isLoading: isSaving,
        onClick: save, __self: this, __source: {fileName: _jsxFileName, lineNumber: 124}}
, "Save"

      )
    )
  )
}

exports. default = SettingsTab
